import React from 'react';
import { PACKAGE_LEVEL } from '@src/constants/package';
import CheckOrCross from '../Shared/CheckOrCross';

const aiEditorPronunciationCheckFeatures = ({ packages }) => {
  const isCheck = (pkg) =>
    [PACKAGE_LEVEL.VIP, PACKAGE_LEVEL.CUSTOM].includes(pkg.level);

  return packages.map((pkg) => (
    <CheckOrCross key={pkg.code} isCheck={isCheck(pkg)} />
  ));
};

export default aiEditorPronunciationCheckFeatures;
